export const call_api_key = '28d47a2645eca67c89f';
export const web_timeout = 43200;

export const countryList = ["US", "GB", "FR", "DE", "IT", "VN"];